import React, { useState, useEffect } from 'react';
import { Button } from '../common/Button';
import * as api from '../../api/user-app-api';

export const OrderSummaryScreen = ({ setView, params, setCart }) => {

    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [placedOrderId, setPlacedOrderId] = useState(null);
    const [order, setOrder] = useState({
        items: params?.cart || [],
        route: params?.route || null,
        address: null,
        totalWeight: 0,
        totalAmount: 0
    });

    const [addresses, setAddresses] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const totalWeight = order.items.reduce((sum, i) => sum + parseFloat(i.weight), 0);
        const totalAmount = order.items.reduce(
            (sum, i) => sum + parseFloat(i.weight) * i.price,
            0
        );

        setOrder(prev => ({ ...prev, totalWeight, totalAmount }));

        fetchAddresses();
    }, []);

    // Load user addresses
    const fetchAddresses = async () => {
        try {
            const userId = localStorage.getItem('userId');
            const res = await api.fetchUserAddresses({ user_id: userId });

            if (res.data.status === 'success') {
                const loadedAddresses = res.data.data;
                setAddresses(loadedAddresses);
                // Auto-select first address
                if (loadedAddresses.length > 0) {
                    setOrder(prev => ({ ...prev, address: loadedAddresses[0] }));
                }
            } else {
                setAddresses([]);
            }
        } catch (err) {
            console.error('Error loading addresses:', err);
            setError('Failed to load addresses.');
        }
    };

    const handleAddressSelect = (addr) => {
        setOrder(prev => ({ ...prev, address: addr }));
    };
    const formatFullAddress = (addr) => {
        return `${addr.house_no}, ${addr.building_name}, ${addr.road_1}, ${addr.road_2}, ${addr.landmark}, ${addr.city}, ${addr.state} - ${addr.pincode}`;
    };

    // Place order after user confirms
    const handleConfirmOrder = async () => {
        if (!order.address) {
            setError('Please select a pickup address');
            return;
        }

        setIsSubmitting(true);
        setError(null);
let finalAmount =
    order.orderType === "DONATE"
        ? 0
        : order.totalAmount;
        try {
            const userId = localStorage.getItem('userId');

            const orderPayload = {
                user_id: userId,
                collection_address: formatFullAddress(order.address),
                scheduled_route: order.route || null,
                total_estimated_value: finalAmount,

                order_type: order.orderType,  // 👈 NEW FIELD

                items: order.items.map(i => ({
                    product_id: i.product_id,
                    quantity: i.weight,
                    price_at_order: i.price
                }))
            };

            const res = await api.placeOrder(orderPayload);

            if (res.data.status === 'success') {

                if (typeof setCart === 'function') {
                    setCart([]);
                }

                localStorage.removeItem('cart');
                sessionStorage.removeItem('cart');

                setPlacedOrderId(res.data.order_id);
                setShowSuccessPopup(true);
            } else {
                setError(res.data.message || 'Failed to confirm order');
            }

        } catch (err) {
            console.error('Order submission failed:', err);
            setError('Server error while confirming order.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-IN', {
            weekday: 'short',
            day: 'numeric',
            month: 'short'
        });
    };

    return (
        <div className="relative h-screen flex flex-col">
            <div className="flex-1 overflow-y-auto p-4 pt-0 pb-28">
                <div className="space-y-6">

                    {/* Pickup Details */}
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                        <h3 className="font-semibold text-gray-800 mb-2">Pickup Details</h3>
                        <p className="text-sm text-gray-600">
                            Route: {order.route?.name || 'Not selected'}
                        </p>
                        {order.route?.window && (
                            <p className="text-sm text-gray-600">Window: {order.route.window}</p>
                        )}
                    </div>

                    {/* Items */}
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                        <h3 className="font-semibold text-gray-800 mb-3">
                            Items ({order.items.length})
                        </h3>

                        {order.items.map((item, idx) => (
                            <div key={idx} className="flex justify-between items-center mb-2">
                                <div>
                                    <p className="text-gray-800">{item.product}</p>
                                </div>

                                <p className="text-xs text-gray-600">₹{item.price}/kg</p>
                            </div>
                        ))}
                    </div>

                    {/* Sell / Donate Selection */}
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                        <h3 className="font-semibold text-gray-800 mb-3">
                            Choose Order Type
                        </h3>

                        <div className="flex space-x-4">

                            {/* SELL */}
                            <label className={`flex items-center space-x-2 px-4 py-2 border rounded-xl cursor-pointer
            ${order.orderType === "SELL"
                                    ? "border-[#01a499] bg-[#01a499]/10"
                                    : "border-gray-200"
                                }`}>

                                <input
                                    type="radio"
                                    name="orderType"
                                    value="SELL"
                                    checked={order.orderType === "SELL"}
                                    onChange={(e) =>
                                        setOrder(prev => ({ ...prev, orderType: e.target.value }))
                                    }
                                />
                                <span className="text-sm font-medium">Sell Scrap</span>
                            </label>

                            {/* DONATE */}
                            <label className={`flex items-center space-x-2 px-4 py-2 border rounded-xl cursor-pointer
            ${order.orderType === "DONATE"
                                    ? "border-[#01a499] bg-[#01a499]/10"
                                    : "border-gray-200"
                                }`}>

                                <input
                                    type="radio"
                                    name="orderType"
                                    value="DONATE"
                                    checked={order.orderType === "DONATE"}
                                    onChange={(e) =>
                                        setOrder(prev => ({ ...prev, orderType: e.target.value }))
                                    }
                                />
                                <span className="text-sm font-medium">Donate Scrap</span>
                            </label>

                        </div>
                    </div>

                    {/* Address Selection */}
                    <div>
                        <div className="flex justify-between items-center mb-3">
                            <h3 className="font-semibold text-gray-800">Select Pickup Address</h3>

                            {addresses.length === 0 && (
                                <button
                                    onClick={() => setView('myAddress', { returnTo: 'orderSummary' })}
                                    className="text-sm text-[#01a499] font-medium"
                                >
                                    + Add New
                                </button>
                            )}
                        </div>

                        {addresses.map((addr, i) => (
                            <div
                                key={i}
                                onClick={() => handleAddressSelect(addr)}
                                className={`p-3 rounded-xl mb-2 border cursor-pointer transition ${order.address?.id === addr.id
                                    ? 'border-[#01a499] bg-[#01a499]/10'
                                    : 'border-gray-200 bg-white'
                                    }`}
                            >
                                <p className="font-medium text-gray-800">
                                    {addr.house_no}, {addr.building_name}
                                </p>

                                <p className="text-sm text-gray-700">
                                    Road 1: {addr.road_1}
                                </p>
                                <p className="text-sm text-gray-700">
                                    Road 2: {addr.road_2}
                                </p>
                                <p className="text-sm text-gray-700">
                                    Landmark: {addr.landmark}
                                </p>

                                <p className="text-sm text-gray-600 mt-1">
                                    {addr.city}, {addr.state} - {addr.pincode}
                                </p>
                            </div>
                        ))}
                    </div>

                    {error && (
                        <div className="p-3 bg-red-100 text-red-700 rounded-lg">
                            {error}
                        </div>
                    )}

                </div>
            </div>

            {/* Bottom Buttons */}
            <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t pb-7 flex space-x-2">

                <Button
                    onClick={() => setView('cart')}
                    className="!bg-gray-500 w-1/3"
                >
                    Back
                </Button>

                <Button
                    onClick={() => setShowConfirmPopup(true)}
                    disabled={isSubmitting || !order.address}
                    className="w-2/3"
                >
                    {isSubmitting ? 'Confirming...' : 'Confirm Order'}
                </Button>

            </div>

            {/* Confirmation Popup */}
            {showConfirmPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl p-6 w-80 shadow-xl">

                        <h3 className="text-lg font-semibold text-gray-800 mb-3 text-center">
                            Confirm Order?
                        </h3>

                        <p className="text-sm text-gray-600 text-center mb-6">
                            Are you sure you want to place this order?
                        </p>

                        <div className="flex space-x-3">
                            <Button
                                onClick={() => setShowConfirmPopup(false)}
                                className="!bg-gray-500 w-1/2"
                            >
                                Cancel
                            </Button>

                            <Button
                                onClick={() => {
                                    setShowConfirmPopup(false);
                                    handleConfirmOrder();
                                }}
                                className="w-1/2"
                            >
                                Yes, Confirm
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            {/* Success Popup */}
            {showSuccessPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl p-6 w-80 shadow-xl text-center">

                        <div className="text-4xl mb-3">✅</div>

                        <h3 className="text-lg font-semibold text-gray-800 mb-2">
                            Order Placed Successfully!
                        </h3>

                        <Button
                            onClick={() => {
                                setShowSuccessPopup(false);
                                setView('orderDetail', { orderId: placedOrderId });
                            }}
                            className="w-full"
                        >
                            View Order
                        </Button>

                    </div>
                </div>
            )}
        </div>
    );
};
